module.exports = __webpack_public_path__ + "img/quiz_bg.e9df2270.jpg";